// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var sliderItem = "ServicesCarouselItem-module--sliderItem--4+3a6";
export var infoWrapper = "ServicesCarouselItem-module--infoWrapper--aYugX";
export var header = "ServicesCarouselItem-module--header--ZzURV";
export var title = "ServicesCarouselItem-module--title--Gpp3W";
export var link = "ServicesCarouselItem-module--link--3gQ45";
export var desktopImage = "ServicesCarouselItem-module--desktopImage--5SzVx";
export var mobileImage = "ServicesCarouselItem-module--mobileImage--Ki3fE";
export var imgBlock = "ServicesCarouselItem-module--imgBlock--YkO4U";